// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import ServicesMain from "./ServiceMain";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import ServerError from "../Error/ServerError";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../config/appConfig";

//IMG



const Services: React.FC = () => {
    const { t } = useTranslation();
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(AGENCY_ID);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    return (
        <>

            <Helmet>
                <title>{t('navigation.servicesLinkTitle')} | {agency?.agencyName ?? t('common.defaultAgencyName')}</title>
            </Helmet>

            <SubHeaderDefault title={t('navigation.servicesLinkTitle')} isSeo={true}/>

            <div id="page" className="services-page">
                <section className="space-ptb">
                    <div className="container-fluid">
                        <div className="row align-items-start">
                            <div className="col-12 mb-4 mb-lg-0">
                                <ServicesMain />
                            </div>
                            {/* Colonna Sidebar (Widgets) */}
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Services;